/**
 * @file: rewriteAuthedPath.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Store } from '@euler/model/entity';

// `login` belongs to the auth linking config: the authenticated navigator
// has no `Login` route, so an already signed-in user opening `/login`
// (stale bookmark, history entry, or typed by hand) matched `NotFound: '*'`
// and got the "OOPS!" page. Send that path to the home screen instead.
const kLoginPathPattern = /^\/?login\/?(?:[?#].*)?$/i;

/**
 * Rewrites a path before it is resolved against the AUTHENTICATED (normal)
 * linking config, mapping auth-only paths onto their signed-in equivalent.
 * @param path the path as received from the url
 * @returns the path to resolve the navigation state from
 */
export function rewriteAuthedPath(
  path: string,
  productLine?: Store['editionProductLine'],
) {
  const target = kLoginPathPattern.test(path) ? '/' : path;
  if (productLine === 'ai' && /^\/?(?:[?#].*)?$/.test(target))
    return '/ai' + target.replace(/^\//, '');
  return target;
}
